import { IKnmResponsibleSubjectType } from 'APIPackage/KnmModule/interfaces/IKnmResponsibleSubjectType';
import { IKnmResponsibleType } from 'APIPackage/CatalogsModule/interfaces/IKnmResponsibleType';

export const createKnmResponsibleTypeSelectOption = (
  knmResponsibleType: IKnmResponsibleType | IKnmResponsibleSubjectType,
) => ({
  ...knmResponsibleType,
  label: knmResponsibleType.name || '',
  value: knmResponsibleType.code,
});
